import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

interface Experience {
  title: string;
  company: string;
  period: string;
  description: string;
  technologies: string[];
  isVisible: boolean;
}

@Component({
  selector: 'app-experience',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.scss']
})
export class ExperienceComponent implements OnInit {
  showAll = false;

  experiences: Experience[] = [
    {
      title: 'Senior Full-Stack Developer',
      company: 'Tech Solutions Inc.',
      period: '2020 - Present',
      description: 'Leading development team, architecting scalable solutions, and mentoring junior developers. Working on enterprise-level applications with millions of users.',
      technologies: ['Angular', '.NET Core', 'PostgreSQL', 'Azure', 'Docker'],
      isVisible: true
    },
    {
      title: 'Full-Stack Developer',
      company: 'Digital Agency',
      period: '2018 - 2020',
      description: 'Developing web applications using modern technologies. Collaborated with design and marketing teams to deliver high-quality solutions for clients.',
      technologies: ['React', 'Node.js', 'MongoDB', 'AWS', 'TypeScript'],
      isVisible: true
    },
    {
      title: 'Junior Developer',
      company: 'StartUp Company',
      period: '2016 - 2018',
      description: 'Started my career learning modern web development practices and technologies. Contributed to various projects and gained valuable experience.',
      technologies: ['JavaScript', 'PHP', 'MySQL', 'Bootstrap', 'jQuery'],
      isVisible: false
    },
    {
      title: 'Frontend Developer',
      company: 'WebStudio',
      period: '2015 - 2016',
      description: 'Focused on creating responsive and interactive user interfaces. Worked with design teams to implement pixel-perfect designs.',
      technologies: ['HTML/CSS', 'JavaScript', 'jQuery', 'SASS', 'Gulp'],
      isVisible: false
    }
  ];

  constructor(public i18n: I18nService) {}

  ngOnInit(): void {
    this.i18n.initializeLanguage();
  }

  toggleExperiences() {
    this.showAll = !this.showAll;
    this.experiences.forEach((exp, index) => {
      if (index >= 2) { // Показуємо перші 2 елементи по замовчуванню
        exp.isVisible = this.showAll;
      }
    });
  }

  get visibleExperiences() {
    return this.experiences.filter(exp => exp.isVisible);
  }

  get buttonText() {
    const key = this.showAll ? 'experience.showLess' : 'experience.showMore';
    return this.i18n.getTranslation(key);
  }
}
